import {
  GET_SCHOOLS,
  GET_SCHOOLS_SUCCESS,
  GET_SCHOOLS_FAILURE,
  GET_SCHOOL,
  GET_SCHOOL_SUCCESS,
  GET_SCHOOL_FAILURE,
  ADD_SCHOOL,
  ADD_SCHOOL_SUCCESS,
  ADD_SCHOOL_FAILURE,
  EDIT_SCHOOL,
  EDIT_SCHOOL_SUCCESS,
  EDIT_SCHOOL_FAILURE,
  CHANGE_SCHOOL_STATUS,
  CHANGE_SCHOOL_STATUS_SUCCESS,
  CHANGE_SCHOOL_STATUS_FAILURE,
} from "../constants";

const initialState = {
  schools: [],
  school: {},
  count: 0,
  isSchoolsLoading: false,
  isSchoolLoading: false,
  error: null,
};

export default function SchoolReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SCHOOLS:
    case ADD_SCHOOL:
    case CHANGE_SCHOOL_STATUS:
      state = {
        ...state,
        isSchoolsLoading: true,
        error: null,
      };
      break;
    case GET_SCHOOL:
    case EDIT_SCHOOL:
      state = {
        ...state,
        isSchoolLoading: true,
        error: null,
      };
      break;
    case GET_SCHOOLS_SUCCESS:
      state = {
        ...state,
        schools: action.payload?.data,
        count: action.payload?.count,
        isSchoolsLoading: false,
      };
      break;
    case ADD_SCHOOL_SUCCESS:
    case CHANGE_SCHOOL_STATUS_SUCCESS:
      state = {
        ...state,
        isSchoolsLoading: false,
      };
      break;
    case GET_SCHOOL_SUCCESS:
    case EDIT_SCHOOL_SUCCESS:
      state = {
        ...state,
        isSchoolLoading: false,
      };
      break;
    case GET_SCHOOLS_FAILURE:
      state = {
        ...state,
        isSchoolsLoading: false,
        schools: [],
        count: 0,
        error: action.payload,
      };
      break;
    case ADD_SCHOOL_FAILURE:
    case CHANGE_SCHOOL_STATUS_FAILURE:
      state = {
        ...state,
        isSchoolsLoading: false,
        error: action.payload,
      };
      break;
    case GET_SCHOOL_FAILURE:
      state = {
        ...state,
        school: {},
        isSchoolLoading: false,
        error: action.payload,
      };
      break;
    case EDIT_SCHOOL_FAILURE:
      state = {
        ...state,
        isSchoolLoading: false,
        error: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
}
